export const arrayOrStringToArray = ({ value }: { value: string[] | string }) => {
	if (typeof value === 'string') {
		return value === 'undefined' ? [] : [value];
	}

	if (Array.isArray(value)) {
		if (value.length === 1 && value[0] === 'undefined') {
			return [];
		}

		return value;
	}

	return [];
};
